import SyBoarding from "../widgets/SyBoarding";

export default function SocialLoginPage({ navigation, route }) {
  return (
    <SyBoarding />
  );
}